import constants from '@/app-configs/constants'

export default [
  {
    path: '/event-logs',
    name: 'event-logs',
    component: () => import('@/views/eventlogs/Logs.vue'),
    meta: {
      pageTitle: 'DEBTIA_EVENT_LOGS',
      breadcrumb: [
        {
          text: 'DEBTIA_EVENT_LOGS',
          active: true,
        },
      ],
      action: constants.action.permissionEventLogsList,
      resource: constants.resource.user,
    },
  },
]
